import React, { useState, forwardRef } from "react";

import { InputText } from "primereact/inputtext";
import MeaCreateModal from "../../../../components/MeaCreateModal";
import classroomsAPI from "../../../../services/classrooms";
import { InputTextarea } from "primereact/inputtextarea";

const CreateClassroomModal = forwardRef((props, ref) => {
  //
  const [name, setName] = useState("");
  const [presentation, setPresentation] = useState("");
  const [capacity, setCapacity] = useState("15");
  //
  return (
    <>
      <MeaCreateModal
        ref={ref}
        title="Créer une salle"
        serviceAPI={classroomsAPI}
        schoolId={props.schoolId}
        trainingId={props.trainingId}
        data={{
          name: name,
          presentation: presentation,
          capacity: parseInt(capacity),
        }}
        onSubmitted={() => {
          setName("");
          setPresentation("");
        }}
      >
        <label htmlFor="name" className="block text-900 font-medium mb-2">
          Nom de la salle
        </label>
        <InputText
          id="name"
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="w-full mb-3"
          autoFocus
        />
        <label
          htmlFor="presentation"
          className="block text-900 font-medium mb-2"
        >
          Présentation
        </label>
        <InputTextarea
          id="presentation"
          type="text"
          value={presentation}
          onChange={(e) => setPresentation(e.target.value)}
          rows={3}
          className="w-full mb-3"
        />
        <label htmlFor="capacity" className="block text-900 font-medium mb-2">
          Capacité
        </label>
        <InputText
          id="capacity"
          type="number"
          value={capacity}
          onChange={(e) => setCapacity(e.target.value)}
          className="w-full mb-3"
        />
      </MeaCreateModal>
    </>
  );
});

export default CreateClassroomModal;
